import React, { useState, useEffect } from 'react';
import { FormikProvider, FieldArray } from 'formik';
import {
  Box,
  Grid,
  TextField,
  Typography,
  Divider,
  Button,
} from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import OrderFileMultiFileForm from './OrderFileMultiFileForm';

const OrderBookForm = ({ type, orderInfo, chance, formik }) => {
  const [siDt, setSiDt] = useState(null);
  const [expDay, setExpDay] = useState(null);
  const [mtnFreeStrtDt, setMtnFreeStrtDt] = useState(null);
  const [mtnFreeEndDt, setMtnFreeEndDt] = useState(null);

  useEffect(() => {
    if (orderInfo) {
      setSiDt(orderInfo.siDt);
      setExpDay(orderInfo.expDay);
      setMtnFreeStrtDt(orderInfo.mtnFreeStrtDt);
      setMtnFreeEndDt(orderInfo.mtnFreeEndDt);
    }
  }, [orderInfo]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <>
      <Box sx={{ mt: 1, px: 2 }}>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          sx={{ py: 1, borderBottom: 1, borderColor: 'divider' }}
        >
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              프로젝트 번호
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.prjNo}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              사업명
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {type === 'add' ? orderInfo?.cstNm : orderInfo?.prjNm}
            </Typography>
          </Grid>
          <Grid item xs={1}>
            <Typography variant="subtitle2" component="div">
              매출처
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography variant="body2" component="div">
              {orderInfo?.partnerNm}
            </Typography>
          </Grid>
        </Grid>
      </Box>

      <Box>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start" // 입력창 상단 라인 정렬
          spacing={1}
          sx={{ width: '100%', mt: 0.5 }}
        >
          {/* 좌측 50%: 날짜 필드 영역 */}
          <Grid item xs={6}>
            <Grid container spacing={1}>
              <Grid item xs={chance?.prjTyp === 'N' ? 3 : 6}>
                <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
                  <DatePicker
                    label="계약일"
                    inputFormat={'yyyy-MM-dd'}
                    value={expDay}
                    onChange={(newValue) => { setExpDay(newValue); onChangeDate(newValue, 'expDay'); }}
                    renderInput={(params) => (
                      <TextField {...params} required fullWidth margin="dense" variant="outlined" size="small"
                        error={formik.touched.expDay && Boolean(formik.errors.expDay)}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={chance?.prjTyp === 'N' ? 3 : 6}>
                <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
                  <DatePicker
                    label="계약완료일"
                    inputFormat={'yyyy-MM-dd'}
                    value={siDt}
                    onChange={(newValue) => { setSiDt(newValue); onChangeDate(newValue, 'siDt'); }}
                    renderInput={(params) => (
                      <TextField {...params} required fullWidth margin="dense" variant="outlined" size="small"
                        error={formik.touched.siDt && Boolean(formik.errors.siDt)}
                      />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              {chance?.prjTyp === 'N' && (
                <>
                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
                      <DatePicker
                        label="무상유지보수 시작일"
                        inputFormat={'yyyy-MM-dd'}
                        value={mtnFreeStrtDt}
                        onChange={(newValue) => { setMtnFreeStrtDt(newValue); onChangeDate(newValue, 'mtnFreeStrtDt'); }}
                        renderInput={(params) => (
                          <TextField {...params} required fullWidth margin="dense" variant="outlined" size="small"
                            error={formik.touched.mtnFreeStrtDt && Boolean(formik.errors.mtnFreeStrtDt)}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                  <Grid item xs={3}>
                    <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
                      <DatePicker
                        label="무상유지보수 종료일"
                        inputFormat={'yyyy-MM-dd'}
                        value={mtnFreeEndDt}
                        onChange={(newValue) => { setMtnFreeEndDt(newValue); onChangeDate(newValue, 'mtnFreeEndDt'); }}
                        renderInput={(params) => (
                          <TextField {...params} required fullWidth margin="dense" variant="outlined" size="small"
                            error={formik.touched.mtnFreeEndDt && Boolean(formik.errors.mtnFreeEndDt)}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Grid container spacing={1}>
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  variant="outlined"
                  size="small"
                  fullWidth
                  id="collCondt"
                  name="collCondt"
                  label="수금조건"
                  value={formik.values.collCondt}
                  onChange={formik.handleChange}
                  error={formik.touched.collCondt && Boolean(formik.errors.collCondt)}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  margin="dense"
                  variant="outlined"
                  size="small"
                  fullWidth
                  id="payCondt"
                  name="payCondt"
                  label="지급조건"
                  value={formik.values.payCondt}
                  onChange={formik.handleChange}
                  error={formik.touched.payCondt && Boolean(formik.errors.payCondt)}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
          sx={{ py: 1 }}
        >
          <Grid item xs={12}>
            <TextField
              margin="normal"
              variant="outlined"
              fullWidth
              id="comment"
              name="comment"
              label="참고사항"
              multiline
              rows={3}
              value={formik.values.comment}
              onChange={formik.handleChange}
              error={formik.touched.comment && Boolean(formik.errors.comment)}
              helperText={formik.touched.comment && formik.errors.comment}
            />
          </Grid>
        </Grid>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box
        sx={{
          px: 1,
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
        }}
      >
        <Box sx={{ mr: 1 }}>
          <FileUploadIcon />
        </Box>
        <Typography variant="subtitle2">파일 업로드</Typography>
      </Box>
      <FormikProvider value={formik}>
        <FieldArray
          name="files"
          render={(arrayHelpers) => (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                py: 1,
                borderTop: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              {formik.values?.files.map((f, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 2,
                    mb: 1,
                    width: '100%',
                  }}
                >
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <OrderFileMultiFileForm
                      file={f}
                      index={index}
                      touched={formik.touched}
                      errors={formik.errors}
                      handleChange={formik.handleChange}
                      handleBlur={formik.handleBlur}
                      handleRemove={() => arrayHelpers.remove(index)}
                    />
                  </Box>
                  {index === 0 && (
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={() => arrayHelpers.push({ fileDesc: '', file: null })}
                      sx={{
                        flexShrink: 0, // 버튼 크기 고정
                        minWidth: '100px',
                        height: '40px',
                        fontWeight: 'bold',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      파일 추가
                    </Button>
                  )}
                  {index > 0 && <Box sx={{ width: '100px', flexShrink: 0 }} />}
                </Box>
              ))}
              {formik.values?.files.length === 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', py: 1 }}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => arrayHelpers.push({ fileDesc: '', file: null })}
                    sx={{ fontWeight: 'bold' }}
                  >
                    파일 추가
                  </Button>
                </Box>
              )}
            </Box>
          )}
        ></FieldArray>
      </FormikProvider>
    </>
  );
};

export default OrderBookForm;
